import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BaseDialog from '../../../ui/BaseDialog';
import DrawerBottom from '../../../ui/DrawerBottom';
import DynamicSvgIcon from '../../../ui/icons/DynamicSvgIcon';

interface CategoryIconSelectorProps {
  categoryIcons: any[];
  open: boolean;
  onClose: () => void;
  onSelect: (category: any) => void;
}

const CategoryIconSelector = (props: CategoryIconSelectorProps) => {
  const {categoryIcons, open, onClose, onSelect} = props,
    theme = useTheme(),
    { t } = useTranslation(['categorySelector']),
    isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  
  const handleOnSelect = (category: any) => {
    onSelect(category);
    onClose();
  };

  const renderCategoryIcons = (): any => {
    return (categoryIcons || []).map((icon: any) => (
      <Stack key={Date().toString()} direction="row" alignItems="center" spacing={2} onClick={() => handleOnSelect(icon)}>
        <DynamicSvgIcon svgUrl={icon} color='#475480' size={30} iconSize={20} />
      </Stack>
    ))
  };

  const title = t('select_category_icon', { ns: 'categorySelector', defaultValue: 'Chọn icon' });

  const content = (
    <Box display='flex' flexWrap='wrap' gap='1em'>
      {renderCategoryIcons()}
    </Box>
  );

  // Render based on device type
  if (isDesktop) {
    return (
      <BaseDialog
        open={open}
        maxWidth='sm'
        onClose={onClose}
        title={title}
      >
        {content}
      </BaseDialog>
    );
  }

  return (
    <DrawerBottom
      open={open}
      onClose={onClose}
      title={title}
      zIndex={10000}
    >
      {content}
    </DrawerBottom>
  );
};

export default CategoryIconSelector;